import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
import subscriptions from './subscriptions'
/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:30
* @route '/teacher/students'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/students',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:30
* @route '/teacher/students'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:30
* @route '/teacher/students'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:30
* @route '/teacher/students'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:57
* @route '/teacher/students/{student}'
*/
export const show = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/teacher/students/{student}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:57
* @route '/teacher/students/{student}'
*/
show.url = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { student: args }
    }

    if (Array.isArray(args)) {
        args = {
            student: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        student: args.student,
    }

    return show.definition.url
            .replace('{student}', parsedArgs.student.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:57
* @route '/teacher/students/{student}'
*/
show.get = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:57
* @route '/teacher/students/{student}'
*/
show.head = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const students = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    subscriptions: Object.assign(subscriptions, subscriptions),
}

export default students